/* =========================================================================
   SENİN KUTUM — Çiçek Sipariş Modülü — Vanilla JS (ES6+), bağımlılık yok
   - Alan bazlı validation
   - Dinamik alanlar (kart notu toggle, ilçe doldurma)
   - Fotoğraf: AYRI upload akışı (uploadFile) → URL text property
   - Sepete ekleme: varyant + tüm properties TEK /cart/add.js JSON çağrısı
   - Kesim saati kontrolü (client). NOT (brief madde 4):
     // TODO: server-side validation gerekli — kesim saati / stok kontrolü
     // Shopify Function veya checkout UI extension ile sunucuda tekrarlanmalı.
   ========================================================================= */
(function () {
  'use strict';

  document.querySelectorAll('[data-fc-form]').forEach(initForm);

  function initForm(root) {
    var ilcelerUrl = root.getAttribute('data-ilceler-url');
    var submitBtn = root.querySelector('[data-fc-submit]');
    var spinner = root.querySelector('[data-fc-spinner]');
    var generalError = root.querySelector('[data-fc-general-error]');

    /* --- 1) İlçe listesini JSON'dan doldur (hardcode DEĞİL) --- */
    var districtSelect = root.querySelector('[data-fc-district]');
    if (districtSelect && ilcelerUrl) {
      fetch(ilcelerUrl)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          (data.ilceler || []).forEach(function (ilce) {
            var opt = document.createElement('option');
            opt.value = ilce;
            opt.textContent = ilce;
            districtSelect.appendChild(opt);
          });
          // Ana sayfadaki bölge seçiciden hatırlanan ilçeyi ön-seçili getir
          try {
            var saved = localStorage.getItem('sk-selected-district');
            if (saved) { districtSelect.value = saved; }
          } catch (e) {}
          // Formdan da ilçe seçilince ana sayfa için hatırla (çift yönlü)
          districtSelect.addEventListener('change', function () {
            try { localStorage.setItem('sk-selected-district', districtSelect.value); } catch (e) {}
          });
        })
        .catch(function () { /* JSON gelmezse select boş kalır, kullanıcı yine de deneyebilir */ });
    }

    /* --- 2) TESLİMAT ARALIĞI kesim mantığı ---
       Her aralığın KENDİ son sipariş saati var (data-slot-cutoff).
       KESİM SADECE "BUGÜN" seçiliyken uygulanır. Yarın/Başka Tarih seçilince
       tüm slotlar AÇILIR (ileri tarihe saat kısıtı yok — bug düzeltmesi).
       Gün değiştiğinde yeniden hesaplanır (updateSlots gün değişiminde çağrılır). */
    var slotsNote = root.querySelector('[data-fc-slots-note]');
    var slotLabels = Array.prototype.slice.call(root.querySelectorAll('[data-fc-slot]'));

    function isTodaySelected() {
      var checkedDay = root.querySelector('[data-fc-day]:checked');
      // Gün seçici yoksa (ör. future dates kapalı) → bugün varsay.
      if (!checkedDay) return true;
      return checkedDay.getAttribute('data-fc-day') === 'today';
    }

    function updateSlots() {
      if (!slotLabels.length) return;
      var todaySelected = isTodaySelected();
      var availableCount = 0;
      var firstAvailableInput = null;
      slotLabels.forEach(function (label) {
        var slotCutoff = label.getAttribute('data-slot-cutoff');
        var input = label.querySelector('[data-fc-slot-input]');
        var unavail = label.querySelector('[data-fc-slot-unavail]');
        // Kesim yalnızca BUGÜN için geçerli. İleri tarihte hep açık.
        var passed = todaySelected && slotCutoff ? isPastCutoff(slotCutoff) : false;
        if (passed) {
          label.classList.add('is-unavailable');
          if (input) { input.disabled = true; input.checked = false; }
          if (unavail) unavail.hidden = false;
        } else {
          label.classList.remove('is-unavailable');
          if (input) input.disabled = false;
          if (unavail) unavail.hidden = true;
          availableCount++;
          if (!firstAvailableInput && input) firstAvailableInput = input;
        }
      });

      // Seçili olan devre dışı kaldıysa, ilk uygun aralığı seç
      var anyChecked = root.querySelector('[data-fc-slot-input]:checked:not([disabled])');
      if (!anyChecked && firstAvailableInput) firstAvailableInput.checked = true;

      // Hiç uygun aralık yoksa (yalnızca bugün olabilir): not göster (form yine AÇIK)
      if (slotsNote) slotsNote.hidden = availableCount !== 0;
    }

    updateSlots();

    /* --- 3) Kart notu toggle (Evet/Hayır) --- */
    var noteWrap = root.querySelector('[data-fc-note-wrap]');
    var noteInput = root.querySelector('[data-fc-note-input]');
    root.querySelectorAll('[data-fc-note-toggle]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        var on = radio.getAttribute('data-fc-note-toggle') === 'on' && radio.checked;
        if (noteWrap) noteWrap.hidden = !on;
        // Not istenmiyorsa değeri temizle (boş property gönderilmesin diye JS'te filtreleriz)
        if (!on && noteInput) noteInput.value = '';
      });
    });

    /* --- 3a) Gönderim Günü: Bugün/Yarın/Başka Tarih → properties[Teslimat Tarihi] --- */
    var dayField = root.querySelector('[data-fc-day-field]');
    if (dayField) {
      var dayRadios = dayField.querySelectorAll('[data-fc-day]');
      var customWrap = dayField.querySelector('[data-fc-day-custom]');
      var customDate = dayField.querySelector('[data-fc-custom-date]');
      var deliveryDate = dayField.querySelector('[data-fc-delivery-date]');

      function updateDeliveryDate() {
        var checked = dayField.querySelector('[data-fc-day]:checked');
        if (!checked) return;
        var type = checked.getAttribute('data-fc-day');
        if (type === 'custom') {
          if (customWrap) customWrap.hidden = false;
          var v = customDate && customDate.value ? customDate.value : '';
          // yyyy-mm-dd → dd.mm.yyyy
          var pretty = v ? v.split('-').reverse().join('.') : '';
          if (deliveryDate) deliveryDate.value = pretty ? ('Başka Tarih – ' + pretty) : 'Başka Tarih';
        } else {
          if (customWrap) customWrap.hidden = true;
          var label = checked.value; // Bugün / Yarın
          var d = checked.getAttribute('data-date') || '';
          if (deliveryDate) deliveryDate.value = label + ' – ' + d;
        }
      }
      // Gün değişince: teslimat tarihini güncelle VE slotları yeniden hesapla
      // (Bugün→kesim uygula, Yarın/Başka Tarih→tüm slotları aç). Bug düzeltmesi.
      dayRadios.forEach(function (r) {
        r.addEventListener('change', function () { updateDeliveryDate(); updateSlots(); });
      });
      if (customDate) customDate.addEventListener('change', updateDeliveryDate);
      updateDeliveryDate();
    }

    /* --- 3b) Ürün üzerine yazı: karakter sayacı (balon VEYA kutu tag'li üründe var).
       Her alanın kendi sayacı olsun (bir üründe ikisi de bulunabilir). --- */
    var writeFields = root.querySelectorAll('[data-fc-balloon]');
    writeFields.forEach(function (field) {
      var input = field.querySelector('[data-fc-balloon-input]');
      var counter = field.querySelector('[data-fc-balloon-counter]');
      if (input && counter) {
        input.addEventListener('input', function () {
          var kalan = 30 - input.value.length;
          counter.textContent = kalan + ' karakter yazabilirsiniz.';
        });
      }
    });

    /* --- 4) Telefon: sadece rakam + boşluk, +90 öneki görsel --- */
    var phoneInput = root.querySelector('[data-fc-phone]');
    if (phoneInput) {
      phoneInput.addEventListener('input', function () {
        this.value = this.value.replace(/[^\d\s]/g, '').slice(0, 14);
      });
    }

    /* --- 5) Fotoğraf: AYRI upload akışı --- */
    var fileInput = root.querySelector('[data-fc-file]');
    var uploadText = root.querySelector('[data-fc-upload-text]');
    var preview = root.querySelector('[data-fc-preview]');
    var previewImg = root.querySelector('[data-fc-preview-img]');
    var removeBtn = root.querySelector('[data-fc-remove]');
    var uploadStatus = root.querySelector('[data-fc-upload-status]');
    var photoUrlInput = root.querySelector('[data-fc-photo-url]');

    if (fileInput) {
      fileInput.addEventListener('change', function () {
        var file = fileInput.files && fileInput.files[0];
        if (!file) return;

        // Doğrulama: tip + boyut
        var okType = ['image/png', 'image/jpeg'].indexOf(file.type) !== -1;
        if (!okType) { setStatus('Sadece PNG veya JPG yükleyebilirsiniz.', 'error'); resetFile(); return; }
        if (file.size > 10 * 1024 * 1024) { setStatus('Dosya en fazla 10 MB olabilir.', 'error'); resetFile(); return; }

        // Önizleme
        var reader = new FileReader();
        reader.onload = function (e) {
          if (previewImg) previewImg.src = e.target.result;
          if (preview) preview.hidden = false;
          if (uploadText) uploadText.textContent = file.name;
        };
        reader.readAsDataURL(file);

        // Ayrı upload akışı
        setStatus('Yükleniyor...', 'uploading');
        uploadFile(file)
          .then(function (url) {
            if (photoUrlInput) photoUrlInput.value = url;
            setStatus('Fotoğraf yüklendi ✓', 'success');
          })
          .catch(function () {
            setStatus('Yükleme başarısız. Tekrar deneyin.', 'error');
            if (photoUrlInput) photoUrlInput.value = '';
          });
      });
    }
    if (removeBtn) {
      removeBtn.addEventListener('click', function () {
        resetFile();
        setStatus('', '');
        if (photoUrlInput) photoUrlInput.value = '';
      });
    }
    function resetFile() {
      if (fileInput) fileInput.value = '';
      if (preview) preview.hidden = true;
      if (previewImg) previewImg.src = '';
      if (uploadText) uploadText.textContent = 'Fotoğraf seç veya sürükle';
    }
    function setStatus(msg, kind) {
      if (!uploadStatus) return;
      uploadStatus.textContent = msg;
      uploadStatus.className = 'fc-upload__status' + (kind ? ' is-' + kind : '');
    }

    /* --- 6) Sepete ekle: validate → tek /cart/add.js
       (Form artık kilitlenmiyor; süresi geçen aralıklar zaten devre dışı.) --- */
    if (submitBtn) {
      submitBtn.addEventListener('click', function () {
        clearErrors(root);
        if (generalError) { generalError.hidden = true; generalError.textContent = ''; }

        var errors = validate(root);
        if (errors.length > 0) {
          showErrors(root, errors);
          return;
        }

        addToCart(root, submitBtn, spinner, generalError);
      });
    }
  }

  /* ================= YARDIMCI FONKSİYONLAR ================= */

  // Kesim saatini (HH:MM) geçtik mi? (mağazanın/ziyaretçinin lokal saati)
  function isPastCutoff(cutoff) {
    var parts = (cutoff || '15:00').split(':');
    var h = parseInt(parts[0], 10) || 15;
    var m = parseInt(parts[1], 10) || 0;
    var now = new Date();
    var cut = new Date();
    cut.setHours(h, m, 0, 0);
    return now > cut;
  }

  // Alan bazlı validation
  function validate(root) {
    var errors = [];

    // required text/textarea/select
    root.querySelectorAll('[data-fc-required]').forEach(function (el) {
      // radyo grubu ise
      if (el.classList.contains('fc-radio-group')) {
        var name = el.querySelector('input[type="radio"]');
        var checked = name && root.querySelector('input[name="' + name.name + '"]:checked');
        if (!checked) errors.push({ el: el, msg: el.getAttribute('data-fc-required'), field: name ? name.name : '' });
        return;
      }
      if (!el.value || !el.value.trim()) {
        errors.push({ el: el, msg: el.getAttribute('data-fc-required'), field: el.getAttribute('name') });
      }
    });

    // Telefon: en az 10 rakam
    var phone = root.querySelector('[data-fc-phone]');
    if (phone && phone.value.replace(/\D/g, '').length < 10) {
      errors.push({ el: phone, msg: 'Geçerli bir telefon numarası giriniz.', field: phone.getAttribute('name') });
    }

    // Kart notu: Evet seçiliyse metin zorunlu
    var noteOn = root.querySelector('[data-fc-note-toggle="on"]');
    var noteInput = root.querySelector('[data-fc-note-input]');
    if (noteOn && noteOn.checked && noteInput && !noteInput.value.trim()) {
      errors.push({ el: noteInput, msg: 'Kart notunu yazınız ya da "Hayır" seçin.', field: 'Kart Notu' });
    }

    // Ürün üzerine yazı onay kutusu (balon VEYA kutu tag'li üründe var).
    // Her yazı alanının kendi onayı ve kendi hata mesajı olsun.
    root.querySelectorAll('[data-fc-balloon]').forEach(function (field) {
      var consent = field.querySelector('[data-fc-balloon-consent]');
      if (consent && !consent.checked) {
        // Onay kutusunun kendi hata <p>'si (Balon Onay / Kutu Onay)
        var consentErr = field.querySelector('.fc-consent-check + .fc-error');
        var consentField = consentErr ? consentErr.getAttribute('data-fc-error-for') : 'Onay';
        errors.push({ el: consent, msg: 'Yazdıklarınızı onaylayınız.', field: consentField });
      }
    });

    // "Başka Tarih" seçiliyse takvimden tarih zorunlu
    var customDayChecked = root.querySelector('[data-fc-day="custom"]:checked');
    var customDateInput = root.querySelector('[data-fc-custom-date]');
    if (customDayChecked && customDateInput && !customDateInput.value) {
      errors.push({ el: customDateInput, msg: 'Lütfen bir teslimat tarihi seçin.', field: 'Teslimat Tarihi' });
    }

    return errors;
  }

  function showErrors(root, errors) {
    errors.forEach(function (err) {
      var field = err.el.closest('.fc-field');
      if (field) field.classList.add('has-error');
      // Alan bazlı hata mesajı
      var propName = (err.field || '').replace(/^properties\[|\]$/g, '');
      var errBox = root.querySelector('[data-fc-error-for="' + propName + '"]');
      if (errBox) errBox.textContent = err.msg;
    });
    // İlk hataya kaydır
    if (errors[0] && errors[0].el.scrollIntoView) {
      errors[0].el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function clearErrors(root) {
    root.querySelectorAll('.fc-field.has-error').forEach(function (f) { f.classList.remove('has-error'); });
    root.querySelectorAll('.fc-error').forEach(function (e) { e.textContent = ''; });
  }

  // === Sepete ekle: varyant + tüm properties tek /cart/add.js JSON ===
  function addToCart(root, submitBtn, spinner, generalError) {
    var skData = window.SK_FC || {};
    var variantId = null;
    for (var k in skData) { if (skData[k] && skData[k].variantId) { variantId = skData[k].variantId; break; } }
    if (!variantId) {
      // Sayfadaki varyant input'undan dene
      var vInput = document.querySelector('[name="id"]');
      if (vInput) variantId = vInput.value;
    }
    if (!variantId) {
      showGeneral(generalError, 'Ürün varyantı bulunamadı. Sayfayı yenileyin.');
      return;
    }

    // properties topla (boş olanları atla)
    var properties = {};
    root.querySelectorAll('[name^="properties["]').forEach(function (input) {
      if (input.type === 'radio' && !input.checked) return;
      var name = input.getAttribute('name').replace(/^properties\[|\]$/g, '');
      var val = (input.value || '').trim();
      if (val) properties[name] = val;
    });

    // Spinner
    submitBtn.disabled = true;
    if (spinner) spinner.hidden = false;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1, properties: properties })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      })
      .then(function () {
        // Sepete gidelim veya cart drawer açalım
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        window.location.href = '/cart';
      })
      .catch(function (err) {
        showGeneral(generalError, (err && err.description) || 'Sepete eklenirken bir hata oluştu.');
      })
      .finally(function () {
        submitBtn.disabled = false;
        if (spinner) spinner.hidden = true;
      });
  }

  function showGeneral(box, msg) {
    if (!box) { alert(msg); return; }
    box.textContent = msg;
    box.hidden = false;
  }

  /* === DOSYA YÜKLEME (AYRI AKIŞ) ===
     Brief madde 1: /cart/add.js file desteklemez, dosya ayrı yüklenir.
     Gerçek endpoint henüz yok.
     // TODO: gerçek upload endpoint'i bağlanacak
     Seçenekler:
       (a) Shopify App Proxy → kendi backend'in → Files API (stagedUploadsCreate + fileCreate)
       (b) Harici storage (Cloudinary, S3 presigned URL)
     Şimdilik placeholder: dosyayı base64 data-url olarak döndürür (geçici).
     PRODUCTION'DA MUTLAKA gerçek bir upload endpoint'i ile değiştirilmeli. */
  function uploadFile(file) {
    return new Promise(function (resolve, reject) {
      // TODO: gerçek upload endpoint'i bağlanacak — aşağıdaki placeholder yalnızca geliştirme içindir
      var reader = new FileReader();
      reader.onload = function (e) {
        // NOT: data-url uzun olur; gerçek çözümde burada bir URL dönmeli.
        resolve(e.target.result);
      };
      reader.onerror = function () { reject(new Error('read-error')); };
      reader.readAsDataURL(file);
    });
  }
})();
